import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { LightBulbIcon } from '@heroicons/vue/outline';
import type { AuraInsight } from '@/types';
import AuraRichText from './AuraRichText.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraInsightCard',
  props: {
    insight: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const { t } = useI18n();

const severity = computed(() => {
    const values = {
        warning: {
            label: t('aura.cards.insight.severity.warning'),
            color: '#F5B041',
            text: '#242B59',
        },
        negative: {
            label: t('aura.cards.insight.severity.negative'),
            color: '#E56B6F',
            text: '#FFFFFF',
        },
        positive: {
            label: t('aura.cards.insight.severity.positive'),
            color: '#48DDC3',
            text: '#242B59',
        },
        neutral: {
            label: t('aura.cards.insight.severity.neutral'),
            color: '#CBD5E1',
            text: '#242B59',
        },
    } as const;

    return values[props.insight.type] || values.neutral;
});

const __returned__ = { props, t, severity, get LightBulbIcon() { return LightBulbIcon }, AuraRichText }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})